module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/instant-quotes-a740ac911ef75122f5b004bad9133430.png";